<h2 mat-dialog-title style="text-align: center">Abnahmeprotokoll ausfüllen</h2>
<mat-dialog-content
  #cnt
  class="mat-typography"
  [ngClass]="customCls"
  style="max-height: 85%"
  id="report_content"
>
  <div class="document-dialog-content">
    <div *ngIf="isLoading" class="document-progress-bar-placeholder"></div>
    <div *ngIf="isLoading" class="document-progress-bar-wrapper">
      <app-document-progress-bar></app-document-progress-bar>
    </div>
    <ng-container *ngIf="!isLoading">
      <div id="report_top"></div>
      <img #docImg *ngIf="!imgUrl" class="img-pdf-content" />
      <img [src]="imgUrl" *ngIf="imgUrl" class="img-pdf-content" />
      <!-- Montagetype-->
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="montageTypeRepair"
      >
        <app-check-state
          [state]="montageType"
          [value]="1"
          (change)="changeType($event)"
        ></app-check-state>
      </div>
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="montageTypeReplace"
      >
        <app-check-state
          [state]="montageType"
          [value]="2"
          (change)="changeType($event)"
        ></app-check-state>
      </div>

      <!-- Arbeitergebnis -->
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="resultStyleOK"
        id="report_middle"
      >
        <app-check-state
          [state]="workResult"
          [value]="1"
          (change)="changeWorkResult($event)"
        ></app-check-state>
      </div>
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="resultStyleNotOK"
      >
        <app-check-state
          cls="check-state-2"
          [state]="workResult"
          [value]="2"
          (change)="changeWorkResult($event)"
        ></app-check-state>
      </div>
      <div class="bg-transparent pos-absolute" style="left: 2.3cm; top: 12.1cm">
        <textarea
          class="bg-transparent"
          *ngIf="commentType === 1"
          rows="5"
          cols="40"
          minlength="5"
          maxlength="220"
          style="
            resize: none;
            width: 16.5cm;
            height: 3.2cm;
            font-size: 0.5cm;
            line-height: 0.8cm;
          "
          #damageNoteText
        >
        </textarea>
        <canvas
          *ngIf="commentType === 2"
          #damageNote
          style="border: 2px dashed grey; width: 16.5cm; height: 3.4cm"
        ></canvas>
        <div></div>
      </div>
      <div
        *ngIf="commentType === 2"
        style="position: absolute; left: 19.1cm; top: 15cm"
      >
        <button (click)="clear('damage_note')">Leeren</button>
      </div>

      <div class="bg-transparent pos-absolute" style="left: 0.5cm; top: 12.1cm">
        <div
          style="padding: 4px"
          [ngClass]="{ 'green-round-icon-border': commentType === 1 }"
        >
          <button mat-icon-button (click)="changeCommentType(1)">
            <mat-icon style="width: 1cm; height: 1cm">keyboard</mat-icon>
          </button>
        </div>

        <div style="width: 0.5cm; height: 0.5cm"></div>
        <div
          style="padding: 0.1cm"
          [ngClass]="{ 'green-round-icon-border': commentType === 2 }"
        >
          <button mat-icon-button (click)="changeCommentType(2)">
            <mat-icon style="width: 1cm; height: 1cm">edit</mat-icon>
          </button>
        </div>
      </div>

      <!-- Bilder -->
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="pictureYes"
      >
        <app-check-state
          cls="fill-report-picture-check-state"
          [state]="pictureResult"
          [value]="1"
          (change)="changePictureResult($event)"
        ></app-check-state>
      </div>
      <div
        class="bg-transparent pos-absolute report-button-container"
        [ngStyle]="pictureNo"
      >
        <app-check-state
          cls="fill-report-picture-check-state"
          [state]="pictureResult"
          [value]="2"
          (change)="changePictureResult($event)"
        ></app-check-state>
      </div>

      <!--Schaden -->
      <div class="bg-transparent pos-absolute" [ngStyle]="damageStyle">
        <canvas
          #canvasDamage
          class="sign-canvas-style"
          [ngStyle]="damageCanvasStyle"
        ></canvas>
        <div style="margin: 0.2cm 0 0 0" class="row-layout flex-content-end">
          <button (click)="clear('damage')">Leeren</button>
        </div>
        <div></div>
      </div>

      <!--Kunde (Unterschrift) -->
      <div
        class="bg-transparent pos-absolute"
        [ngStyle]="signCustomerStyle"
        id="report_down"
      >
        <canvas
          #signCanvasCustomer
          class="sign-canvas-style"
          [ngStyle]="signCustomerCanvasStyle"
        ></canvas>
        <div
          style="margin: 0.6cm 0 0.5rem 0"
          class="row-layout flex-content-end"
        >
          <button (click)="clear('customer_sign')">Leeren</button>
        </div>
        <div></div>
      </div>

      <!--Montageleiter (Unterschrift)-->
      <div class="bg-transparent pos-absolute" [ngStyle]="signMontageStyle">
        <canvas
          #signCanvas
          class="sign-canvas-style"
          [ngStyle]="signMontageCanvasStyle"
        ></canvas>
        <div
          style="margin: 0.6cm 0 0.5rem 0"
          class="row-layout flex-content-end"
        >
          <button (click)="clear('montage_sign')">Leeren</button>
        </div>
        <div></div>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout flex-content-space-between pdf-dialog-actions"
>
  <div>
    <button mat-button class="document-cancel" (click)="scrollTop(0)">
      Oben
    </button>
    <button mat-button class="document-cancel" (click)="scrollTop(1)">
      Mitte
    </button>
    <button mat-button class="document-cancel" (click)="scrollTop(2)">
      Unten
    </button>
  </div>
  <div>
    <button mat-button class="document-cancel" (click)="signClose(false)">
      Abbrechen
    </button>
    <button mat-button class="document-save" (click)="signClose(true)">
      Speichern
    </button>
  </div>
</div>
